import controller from './upload.controller';
import template from './upload.html';
import './upload.scss';

export default {
	path:           '/upload',
	template,
	controllerAs:   '$ctrl',
	controller,
	title:          'common.import',
	reloadOnSearch: false,
};
